var map = {
	"./font_anzu_daughter.png": "oWbf",
	"./font_banana_son.png": "+s8M",
	"./font_beautiful_daughter.png": "FIbV",
	"./font_darts_daughter.png": "mEzk",
	"./font_darts_son.png": "vN9s",
	"./font_genshin_daughter.png": "0TTT",
	"./font_genshin_son.png": "DmHZ",
	"./font_hui_daughter.png": "08gO",
	"./font_hui_son.png": "MbZB",
	"./font_kacho_son.png": "CQUD",
	"./font_malecharacter_son.png": "nfwL",
	"./font_uzura_daughter.png": "k6II"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3/5R";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent ^\.\/font_.*\.png$
// module id = 3/5R
// module chunks = 0